export const randomNumber = (length) => {
  const randomNumber = Math.floor(Math.random() * Math.pow(10, length));
  return String(randomNumber).padStart(length, "0");
};
